import {Component, OnInit}        from '@angular/core';
declare var $: any;
import {Sucursal} from '../sucursal/sucursal';
import {SucursalService} from '../sucursal/sucursal.service';
import {Empresa} from '../empresa/empresa';
import {EmpresaService} from '../empresa/empresa.service';
import {PermisoService} from '../permiso/permiso.service';
import {Router} from '@angular/router';
import {LoginService} from '../login/login.service';
import {Gateway} from './gateway';
import {GatewayService} from './gateway.service'
import {NodoService} from '../nodo/nodo.service';
import {Nodo} from '../nodo/nodo';
import 'rxjs/Rx';

import myGlobals = require('../config');

@Component({
    selector: 'gateway',
    template: require('../../app/gateway/gateway.component.html'),
    styles: [require('../../app/gateway/gateway.component.css')]
})
export class GatewayComponent implements OnInit {
    gateway: Gateway;
    idSeleccionado;
    active: any;
    empresas: Empresa[];
    empresa: Empresa;
    permisos: any;
    deshabilitar: boolean;
    sucursales: Sucursal[];
    sucursal: Sucursal;
    gateways: Gateway[];
    nodos: Nodo[];

    constructor(private sucursalService: SucursalService,
                private empresaService: EmpresaService,
                private loginService: LoginService,
                private permisoService: PermisoService,
                private gatewayService: GatewayService,
                private nodoService: NodoService,
                private router: Router) {
    }

    ngOnInit() {
        window.scrollTo(0, 0);

        //Pedir permisos
        this.permisos = new Map();
        this.permisoService.getPermiso("gateway").subscribe(permisos => {
            for (let permiso of permisos.tipoPermiso) {
                this.permisos.set(permiso.descripcion, true);
            }
            //Si no tiene permiso para ver redirijo
            if (!this.permisos.get("read"))
                this.router.navigate(['/home']);
        });
        //Inicializar tabla
        $("#grid-data").bootgrid({
            ajax: true,
            url: myGlobals.default.BASE_URL + "/gateway/gatewayTable",
            selection: true,
            multiSelect: false,
            rowSelect: true,
            formatters: {
                "empresa": function (column, row) {
                    return row.sucursal_id.empresa.descripcion
                },
                "sucursal": function (column, row) {
                    return row.sucursal_id.descripcion
                },
                "estado": function (column, row) {
                    return row.estado == true ? "Activo" : "<span class=\"label label-danger\">Inactivo</span>"
                }
            },
            ajaxSettings: {
                headers: {
                    "Authorization": this.loginService.getToken()
                },
                method: "GET"
            }
        });
        //Cerrar alert
        $("#alertSeleccion").hide();
        //Inicializar banderas para resetear forms
        this.active = true;
        //Inicializar gateway
        this.gateway = new Gateway();
        //Inicializar bandera deshabilitar
        this.deshabilitar = true;
        //Cargar empresas
        this.empresaService.getEmpresas()
            .subscribe(empresas => {
                this.empresas = empresas;
            });
    }

    ngOnDestroy() {
    }

    agregar() {
        //Reseteo formEmpresa para eliminar errores
        this.active = false;
        setTimeout(() => this.active = true, 0);
        //Inicializo variables
        this.gateway = new Gateway();
        //Seteo bandera para deshabilitar
        this.deshabilitar = false;
        //Muestro modal
        $("#modalGateway").modal("show");
        //Cerrar alert
        $("#alertSeleccion").hide();
    }

    modificar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco usuario
                this.gatewayService
                    .getGateway(this.idSeleccionado)
                    .subscribe(gateway => {
                        this.gateway = gateway;
                        this.cargarSucursales(gateway.sucursal_id.empresa);
                    });
                //Seteo bandera para deshabilitar
                this.deshabilitar = false;
                //Muestro modal
                $("#modalGateway").modal("show");
            }
        }
    }

    eliminar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco gateway
                this.gatewayService
                    .getGateway(this.idSeleccionado)
                    .subscribe(gateway => {
                        this.gatewayService.delete(gateway).subscribe(() => $("#grid-data").bootgrid("reload"));
                    });
            }
        }
    }

    ver() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco gateway
                this.gatewayService
                    .getGateway(this.idSeleccionado)
                    .subscribe(gateway => {
                        this.gateway = gateway;
                    });
                //Seteo bandera para deshabilitar
                this.deshabilitar = true;
                //Muestro modal
                $("#modalGateway").modal("show");
            }
        }
    }

    exportar() {
        //Obtener id seleccionado
        this.idSeleccionado = $("#grid-data").bootgrid("getSelectedRows")[0];
        //Si no hay nada seleccionado mostrar alert
        if (this.idSeleccionado == undefined) {
            $("#alertSeleccion").show();
        }
        else {
            if (this.idSeleccionado != "0") {
                //Cerrar alert
                $("#alertSeleccion").hide();
                //Busco gateway
                this.nodoService
                    .getNodosByGateway(this.idSeleccionado)
                    .subscribe(nodos => {
                        this.nodos = nodos;
                        var desGateway = "";
                        if (nodos.length > 0) {
                            let dataString = "";
                            let csvContent = nodos[0].gateway_id._id + "," + nodos[0].gateway_id.pass + "\n";
                            nodos.forEach(function (nodo, index) {
                                desGateway = nodo.gateway_id.descripcion.replace(" ", "");
                                dataString = nodo.etiqueta + "," + nodo.tipo_id.descripcion + "," + nodo.sensores_id.length;
                                //if (nodo.tipo_id.rangoDesde != undefined && nodo.tipo_id.rangoHasta != undefined)
                                //dataString += "," + nodo.tipo_id.rangoDesde + "," + nodo.tipo_id.rangoHasta;
                                csvContent += dataString;

                                if (nodo.tipo_id.descripcion.toLowerCase().trim() == "corriente"
                                    || nodo.tipo_id.descripcion.toLowerCase().trim() == "tension"
                                    || nodo.tipo_id.descripcion.toLowerCase().trim() == "tensión") {
                                    csvContent += ",";
                                    nodo.sensores_id.forEach(function (sensor, index) {
                                        dataString = sensor.tipo_id.rangoDesde + "," + sensor.tipo_id.rangoHasta;
                                        console.log(index);
                                        csvContent += index < nodo.sensores_id.length - 1 ? dataString + "," : (dataString + "");
                                    })
                                }
                                csvContent += "/";
                                nodo.sensores_id.forEach(function (sensor, index) {
                                    if (sensor.tipo_id.m && sensor.tipo_id.h) {
                                        dataString = sensor.tipo_id.m + "," + sensor.tipo_id.h;
                                        console.log(index);
                                        csvContent += index < nodo.sensores_id.length - 1 ? dataString + "," : (dataString + "");
                                    }
                                    // else
                                    //     csvContent += "\n";
                                });
                                csvContent += "\n";

                            });

                            /*for(let gateway of this.gateways){
                             if(gateway._id == this.idSeleccionado){
                             this.gateway = gateway;
                             break;
                             }
                             }*/

                            var a = document.createElement('a');
                            a.href = 'data:attachment/csv,' + encodeURIComponent(csvContent);
                            a.target = '_blank';

                            var d = new Date();

                            var datestring = d.getDate() + "" + (d.getMonth() + 1) + "" + d.getFullYear() + " " +
                                d.getHours() + "" + d.getMinutes();

                            a.download = desGateway + "-" + datestring + '.csv';

                            document.body.appendChild(a);
                            a.click();
                        }
                        else
                            alert("El gateway seleccionado no tiene nodos cargados.")
                    });
                this.deshabilitar = true;
            }
        }
    }

    save() {
        this.gatewayService
            .save(this.gateway)
            .subscribe((gateway) => {
                this.gateway = gateway;
                //Inicializo variables
                this.gateway = new Gateway();
                //Ocultar modal
                $("#modalGateway").modal("hide");
                //Reseteo formGateway para eliminar errores
                this.active = false;
                setTimeout(() => this.active = true, 0);
                //Recargo tabla
                $("#grid-data").bootgrid("reload")
            })
    }

    cargarSucursales(idEmpresa) {

        this.sucursalService.getSucursalByEmpresa(idEmpresa)
            .subscribe(sucursales => {
                this.sucursales = sucursales;
            });
    }

    hideAlert() {
        $("#alertSeleccion").hide();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/gateway/gateway.component.ts